import { render, staticRenderFns } from "./StandardInjectionsListComponent.vue?vue&type=template&id=406d4cc8&scoped=true&"
import script from "./StandardInjectionsListComponent.vue?vue&type=script&lang=js&"
export * from "./StandardInjectionsListComponent.vue?vue&type=script&lang=js&"
import style0 from "./StandardInjectionsListComponent.vue?vue&type=style&index=0&id=406d4cc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406d4cc8",
  null
  
)

export default component.exports